<template>
  <ion-page
    class="box flex-column align-center justify-between"
    :class="aiTheme"
    :style="{ '--top': type == 'hasCancel' ? '15px' : '0' }"
  >
    <div class="modal-content">
      <img class="nav-img" :src="isManual ? currentArtificialNav : defaultNav" alt="" />
      <div class="tips">
        <div class="tips-title">切换训练方式</div>
        <div id="txtClipboard" class="content-value">
          开启训练后，本轮训练将不可再切换训练方式，如需再次切换请在下一轮训练开始前选择
        </div>
        <div class="tips-confirm">
          <div class="btn1" @click="cancel">取消</div>
          <div class="btnClipboard cursor-pointer" @click="confirm">切换</div>
        </div>
      </div>
    </div>
  </ion-page>
</template>
<script>
import { IonPage, modalController } from "@ionic/vue"
import mqttServer from "@/js/mqtt"

import { chevronBackOutline } from "ionicons/icons"
import currentAiNav from "@/assets/teacher_index/version5/current_ai.svg"
import currentArtificialNav from "@/assets/teacher_index/version5/current_artificial.svg"

export default {
  name: "EduPrintAddress",
  components: {
    IonPage,
  },
  props: ["hasModeSwitch", "isManual"],
  setup() {
    return {
      chevronBackOutline,
    }
  },
  data() {
    return {
      printAddress: undefined,
      aiTheme: undefined,
      generateContent: null,
      defaultNav: currentAiNav,
      currentArtificialNav: currentArtificialNav,
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "EduPrintAddress",
        userType: 1,
        data: null,
        fn: "",
        params: null,
        timestamp: " ",
      },
    }
  },
  mounted() {
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

    this.generateContent = localStorage.getItem("GenerateContent")
    if (this.generateContent) {
      this.aiTheme = localStorage.getItem("ai-theme")
    } else {
      this.aiTheme = undefined
    }
  },
  methods: {
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },
    async confirm() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "confirmSync",
          msgType: "function",
        })
        .then(async () => {
          await modalController.dismiss("NEXT", "", "switchModeDialog")
        })
    },
    async confirmSync() {
      await modalController.dismiss("NEXT", "", "switchModeDialog")
    },
    async cancel() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "cancelSync",
          msgType: "function",
        })
        .then(async () => {
          modalController.dismiss("", "", "switchModeDialog")
        })
    },

    async cancelSync() {
      modalController.dismiss("", "", "switchModeDialog")
    },
  },
}
</script>

<style scoped lang="less">
@import "@/theme/ai-theme.less";

.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //padding: 25px 20px 25px 20px;
}

.modal-content {
  width: 100%;
  background-color: #fff;
  border-radius: 1.3rem;

  .nav-img {
    width: 100%;
  }
}

.tips {
  padding: 1rem;

  &-title {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  &-confirm {
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    gap: 20px;
  }
}

.top {
  padding: var(--top);
}

.address input {
  border: 0;
  width: 100%;
}

.btnClipboard {
  width: 100%;
  height: 80%;
}

/* new ui */
.close-pic {
  width: 18px;
  height: 18px;
  display: block;
  margin-left: auto;
}

.title {
  color: #262626;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 1rem;
}

.content-value {
  color: #9a9b9c;
  font-size: 0.9rem;
  text-align: left;
  line-height: 1.5rem;
  white-space: pre-wrap;
}

.btnClipboard {
  width: 8rem;
  height: 3rem;
  border-radius: 1.5rem;
  background: var(--theme-color);
  line-height: 3rem;
  color: #fff;
  text-align: center;
  font-size: 0.9rem;
}

.btn-box {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  width: 100%;
  margin-bottom: 20px;
}

.btn1 {
  /* line-height: px; */
  width: 8rem;
  height: 3rem;
  line-height: 3rem;
  color: #868f9e;
  text-align: center;
  font-size: 0.9rem;
  border-radius: 1.5rem;
  background-color: #f2f3f6;
}

.btn2 {
  width: 80px;
  border-radius: 15px;
  background: var(--theme-color);
  line-height: 44px;
  color: #fff;
  text-align: center;
  font-size: 17px;
}
</style>
